import React from 'react';
import { Stack, TextField } from '@mui/material';

const StepVisionValues = ({ formData, handleChange }) => (
  <Stack spacing={3}>
    <TextField
      label="Missão"
      name="mission"
      value={formData.mission}
      onChange={handleChange}
      multiline
      rows={2}
    />
    <TextField
      label="Visão"
      name="vision"
      value={formData.vision}
      onChange={handleChange}
      multiline
      rows={2}
    />
    <TextField
      label="Valores"
      name="values"
      value={formData.values}
      onChange={handleChange}
      multiline
      rows={2}
    />
  </Stack>
);

export default StepVisionValues;
